<script setup lang="js">
import Title from "@/components/Title.vue";
import Context from "@/components/Context.vue";


import ContextColors from "@/components/ContextColors.vue";
import {ref} from "vue";
const  ypd =ref('https://cos5.51tgqj.com/techming/img/5ypd@2x.png');
const  image= ref('https://cos5.51tgqj.com/techming/img/SJBJH@2x.png');
const  JSMS= ref('https://cos5.51tgqj.com/techming/img/JSMS@2x.png');
const txlog = ref('https://cos5.51tgqj.com/techming/img/txlgo@2x.png');
const SD = ref('https://cos5.51tgqj.com/techming/img/SD@2x.png');
const LH = ref('https://cos5.51tgqj.com/techming/img/LH@2x.png');
const LHs = ref('https://cos5.51tgqj.com//2025/07/31/7e5a26b4c09241f8bc7d0e4f2c43af2d.png');
const SLOGO = ref('https://cos5.51tgqj.com/techming/img/SLOGO@2x.png');
const mtbd = ref('https://cos5.51tgqj.com/techming/img/mtbd@2x.png');
const mtlog = ref('https://cos5.51tgqj.com/techming/img/mtlog@2x.png');
const zpcb = ref('https://cos5.51tgqj.com/techming/img/zpcb@2x.png');
const ygxl = ref('https://cos5.51tgqj.com/techming/img/ygxl@2x.png');
const yggm = ref('https://cos5.51tgqj.com/techming/img/yggm@2x.png');
const shyxl = ref('https://cos5.51tgqj.com/techming/img/shyxl@2x.png');
const qfzp = ref('https://cos5.51tgqj.com/techming/img/qfzp-s@2x.png');
const zgm = ref('https://cos5.51tgqj.com/techming/img/ZGM-S@2x.png');
const wszp = ref('https://cos5.51tgqj.com/techming/img/wszp-s@2x.png');
const mcf = ref('https://cos5.51tgqj.com/techming/img/mcf-s@2x.png');
const jzjl = ref('https://cos5.51tgqj.com/techming/img/jzjl-s@2x.png');
const cyp = ref('https://cos5.51tgqj.com/techming/img/cyp-s@2x.png');
const jlhj = ref('https://cos5.51tgqj.com/techming/img/jlhj@2x.png');
const cygzl = ref('https://cos5.51tgqj.com/techming/img/cygzl@2x.png');
const ggfwzc = ref('https://cos5.51tgqj.com/techming/img/ggfwzc@2x.png');
const btwcy = ref('https://cos5.51tgqj.com/techming/img/btwcy@2x.png');
const qczx = ref('https://cos5.51tgqj.com/techming/img/qczx@2x.png');
const sxjd = ref('https://cos5.51tgqj.com/techming/img/sxjd@2x.png');
const qfzp_z = ref('https://cos5.51tgqj.com/techming/img/qfzp@2x.png');
</script>

<template>
  <div>
    <Title title="服务数据" class="mb-4"></Title>
    <context-colors color="bg-[#ffffff]">
      <div class="flex flex-wrap justify-between md:px-2 text-center">
        <div class="lg:basis-1/6 text-center items-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute items-end mb-8">
              <text class="text-[3.2rem]">9</text>
              <text class="text-[1.5rem]">个</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold">川渝人资IP</text>
        </div>
        <div class="lg:basis-1/6 text-center items-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute items-end mb-8">
              <text class="text-[3.2rem]">131</text>
              <text class="text-[1.5rem]">个</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold ">就业服务点位</text>
        </div>
        <div class="lg:basis-1/6 text-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute">
              <text class="text-[3.2rem]">5000</text>
              <text class="text-[1.88rem]">+</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold ">企业用户</text>
        </div>
        <div class="lg:basis-1/6 text-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute">
              <div class="">
                <text class="text-[3.2rem]">25</text>
                <text class="text-[1.5rem]">万</text>
              </div>
              <text class="text-[1.88rem]">+</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold ">累计用户</text>
        </div>
        <div class="lg:basis-1/6 text-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute">
              <div class="">
                <text class="text-[3.2rem]">30</text>
                <text class="text-[1.5rem]">万</text>
              </div>
              <text class="text-[1.88rem]">+</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold ">社群用户</text>
        </div>
        <div class="lg:basis-1/6 text-center">
          <div class="justify-center flex items-center">
            <el-image :src='image' class="h-[11rem] w-[10rem]"></el-image>
            <div class="flex absolute">
              <div class="">
                <text class="text-[3.2rem]">400</text>
                <text class="text-[1.5rem]">万</text>
              </div>
              <text class="text-[1.88rem]">+</text>
            </div>
          </div>
          <text class="text-[1.5rem] font-bold ">覆盖人群</text>
        </div>
      </div>
    </context-colors>

    <context class="text-center">
      <Title title="数智稳就业"/>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <el-image fit="cover" :src='JSMS' class="w-fit"/>
    </context>

    <context>
      <Title title="项目优势"/>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <div class="w-full h-fit flex flex-row justify-between">
        <div class="basis-2/5 mx-2 flex bg-[#4e6ff5] items-center text-center justify-center md:col-span-2">
          <div class="">
            <p class="text-white text-[2.5rem] md:text-[2.5rem] lg:text-[5rem] font-bold">四大核心</p>
            <p class="text-white text-[2.5rem] md:text-[2.5rem] lg:text-[5rem] font-bold">引擎驱动</p>
            <div class="text-black text-[1.5rem] md:text-[1.5rem] lg:text-[3.5rem] border-[#000000] border-2 rounded-full p-2">
              差异化优势
            </div>
            <el-image class="mt-4 w-1/4" :src="SD"/>
          </div>
        </div>
        <div class="basis-1/4 md:mx-1 lg:ml-16">
          <div class="border-white border-2 text-center justify-center flex flex-col  py-10">
            <div class="text-[2rem] md:text-[2rem] lg:text-[4rem] text-white flex justify-center relative">
              <p>品牌</p>
              <p class="absolute right-6 -top-8">+</p>
            </div>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">政企共建就业IP</p>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem] ">塑造公信力</p>
          </div>
          <div class="border-white border-2 text-center justify-center flex flex-col py-10 mt-5 md:mt-5 lg:mt-10">
            <div class="text-[2rem] md:text-[2rem] lg:text-[4rem] text-white flex justify-center relative">
              <p>创新</p>
              <p class="absolute right-6 -top-8">+</p>
            </div>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">轻型创业孵化 </p>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">激活基层活力 </p>
          </div>
        </div>
        <div class="basis-1/4 md:mx-1 lg:ml-16">
          <div class="border-white border-2 text-center justify-center flex flex-col  py-10">
            <div class="text-[2rem] md:text-[2rem] lg:text-[4rem] text-white flex justify-center relative">
              <p>数字</p>
              <p class="absolute right-6 -top-8">+</p>
            </div>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">技术赋能精准服务</p>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">打破信息孤岛</p>
          </div>

          <div class="border-white border-2 text-center justify-center flex flex-col py-10 mt-5 md:mt-5 lg:mt-10">
            <div class="text-[2rem] md:text-[2rem] lg:text-[4rem] text-white flex justify-center relative">
              <p>本地</p>
              <p class="absolute right-6 -top-8">+</p>
            </div>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">社区就是孵化器</p>
            <p class="text-white text-[0.1rem] md:text-[0.1rem] lg:text-[1.3rem]">街坊都是合伙人</p>
          </div>
        </div>
      </div>
    </context>
    <Title title="价值成效"/>
    <context>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s mb-4"></div>
      <div class="text-3xl md:text-3xl lg:text-[1.8rem] text-white pb-4">终端用户直击痛点</div>
      <div class="pt-2 md:pt-2 lg:pt-1">
        <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
          <text class="font-bold">就业便捷化：</text>基层求职者通过“前锋直聘”“川渝聘”等平台，30分钟找到匹配岗位，满意度超80%。
        </div>
        <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] pt-2 md:pt-2 lg:pt-4">
          <text class="font-bold">创业低门槛：</text>“创在家门口”提供“1天培训+3天试运营+全程指导”，创业成功率提升50%。
        </div>
      </div>

      <div class="pt-2 md:pt-2 lg:pt-4 lg:justify-center flex overflow-x-auto">
        <div class="lg:basis-1/5 flex flex-col justify-center text-center items-center">
          <div>
            <el-image :src="txlog"  class="w-2/3"/>
          </div>
          <div class="text-white mt-6 w-56">数据来源：腾讯官方</div>
        </div>

        <div class="lg:basis-1/5  text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LH' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">151513</text>
              <p class="text-[1rem]">平台累计用户</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5  text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LH' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">2502</text>
              <p class="text-[1rem]">日平均访人次</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5  text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LH' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">65%</text>
              <p class="text-[1rem]">四川用户占比</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5  text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LH' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">524100</text>
              <p class="text-[1rem]">页面累计访问</p>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 lg:justify-center flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/5 flex flex-col justify-center text-center items-center">
          <el-image :src="SLOGO" fit="contain"  class="h-[5rem]"/>
          <p class="text-white mt-6 w-56">数据来源：川渝聘请</p>
        </div>
        <div class="lg:basis-1/5 text-center">
          <div class="justify-center flex items-center relative">
            <el-image :src='LHs' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">3385</text>
              <p class="text-[1rem]">用工企业</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5 text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LHs' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">876000</text>
              <p class="text-[1rem]">人岗匹配信息</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5 text-center  relative">
          <div class="justify-center flex items-center">
            <el-image :src='LHs' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">15924</text>
              <p class="text-[1rem] px-8 md:px-8 lg:px-0 ">单条用工信息浏览量最高</p>
            </div>
          </div>
        </div>
        <div class="lg:basis-1/5 text-center relative">
          <div class="justify-center flex items-center">
            <el-image :src='LHs' class="h-[10.5rem] w-[10rem]"></el-image>
            <div class="absolute items-end text-white">
              <text class="text-[2rem]">138</text>
              <p class="text-[1rem]  px-9 md:px-9 lg:px-0 ">单条岗位应聘人数最多</p>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex justify-between">
        <el-image :src="mtbd" />
        <el-image :src="mtlog" />
      </div>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s "></div>
      <div class="text-3xl md:text-3xl lg:text-[1.8rem] text-white">经济效益量化</div>
      <div class="pt-2 md:pt-2 lg:pt-4">
        <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
          <text class="font-bold">企业降本：</text>：招聘成本降低30%，用工效率提升40%。
        </div>
        <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] pt-2 md:pt-2 lg:pt-4">
          <text class="font-bold">政府增效：</text>公共服务支出节约20%，帮助区域企业用工规模年增30%。
        </div>
      </div>
      <div class="mt-4 flex  flex-nowrap justify-between max-w-full overflow-x-auto">
        <div class="">
          <el-image :src="zpcb" class="h-[15rem] w-[14rem]"/>
        </div>
        <div class="">
          <el-image :src="ygxl" class="h-[15rem] w-[14rem]"/>
        </div>
        <div class="">
          <el-image :src="ggfwzc" class="h-[15rem] w-[14rem]"/>
        </div>
        <div class="">
          <el-image :src="yggm" class="h-[15rem] w-[14rem]"/>
        </div>
      </div>
      <div class="w-full h-[0.08rem]  my-4 bg-[#54C3F1] border-s"></div>
      <div class="flex justify-center ">
        <div class="basis-3/5 flex flex-col justify-center">
          <div class="text-3xl md:text-3xl lg:text-[1.8rem] text-white pb-4 md:pb-4 lg:pb-8">社会影响力</div>
          <div class="pt-2 md:pt-2 lg:pt-4">
            <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
              <text class="font-bold">普惠就业：</text>：累计帮助3万人就业，60%为农村劳动力，20%为退役军人、残障人士等特殊群体。
            </div>
            <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] pt-2 md:pt-2 lg:pt-4">
              <text class="font-bold">乡村振兴：</text>通过“零工市场（驿站）+数智平台”带动县域灵活就业，偏远地区求职者就业率提升35%。
            </div>
          </div>
        </div>
        <div class="basis-2/5 text-center items-center flex justify-center">
          <el-image :src="shyxl" class="w-2/3 md:w-2/3 lg:w-1/3"/>
        </div>
      </div>
    </context>
    <context>
      <Title title="就创品牌"/>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s "></div>
      <div class="flex justify-between max-w-full overflow-x-auto">
        <div class="md:mr-14">
          <el-image alt="测试" :src="zgm" class="h-[18rem] w-[9rem]"/>
        </div>
        <div class="md:mr-10">
          <el-image :src="qfzp" class="h-[18rem] w-[11rem]"/>
        </div>
        <div class="md:mr-10">
          <el-image :src="wszp" class="h-[18rem] w-[10rem]"/>
        </div>
        <div class="md:mr-10">
          <el-image :src="mcf" class="h-[18rem] w-[14rem]"/>
        </div>
        <div class="md:mr-10">
          <el-image :src="jzjl" class="h-[18rem] w-[11rem]"/>
        </div>
        <div class="md:mr-10">
          <el-image :src="cyp" class="h-[18rem] w-[12rem]"/>
        </div>
      </div>
    </context>
    <context>
      <Title title="就创阵地"/>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s "></div>
      <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 p-2 lg:mr-4">
          <el-image :src="jlhj" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 p-2 lg:ml-4 text-right">
          <el-image :src="cygzl" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
      </div>
      <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 lg:mr-4 p-2">
          <el-image :src="btwcy" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 lg:ml-4 p-2 text-right">
          <el-image :src="qczx" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
      </div>
      <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 lg:mr-4 p-2">
          <el-image :src="sxjd" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 lg:ml-4 p-2 text-right">
          <el-image :src="qfzp_z" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
      </div>
    </context>
    <context>
      <Title title="就创动态"/>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
        <div class="md:w-3/4 p-5 lg:w-4/6">
          <el-image :src="ypd" class="md:w-full" fit="contain"/>
        </div>
        <div class="md:w-full">
          <ul class=" ml-10 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-white content-center">
            <li class="mb-4">●   才聚賨城 职等你来！2025年广安夏季招聘会新鲜出炉。</li>
            <li class="mb-4">●   走！去开辟新赛道</li>
            <li class="mb-4">●   川渝高竹新区数智零工市场：点亮就业新灯塔，驱动双城新引擎</li>
            <li class="mb-4">●   邻水：创业就业持续“给力” 暖了民心添了信心</li>
            <li class="mb-4">●   前锋直聘——就业不用去远方 前锋就是好地方</li>
            <li class="mb-4">●   家门口的创业梦，白塔微创园等您来！</li>
            <li class="mb-4">●   九龙后街数智零工驿站：社区就是孵化器 邻里都是合伙人</li>
            <li class="mb-4">●   睦春风——社区“新柒柿”，等你大展拳脚。</li>
            <li class="mb-4">●   手把手教您直播，居家创业不是梦。</li>
          </ul>
        </div>
      </div>
    </context>
  </div>
</template>

<style scoped>

</style>
